/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimeEntryType {
    CHAT_AUTO = 'chatAuto',
    MANUAL = 'manual',
}
